var alignmentStyle = {"alignLeft":"_7FyJG","textWrapNowrap":"tpl8A","alignRight":"rabso","alignCenter":"h1Jhe","sizeFullWidth":"cbQaD","renderedInTable":"OmMEg","sizeOriginal":"CgZdt","sizeContent":"SmuTx","sizeSmall":"G2QBM","sizeSmallCenter":"kFx9o","flex":"S4sOC","LEFT":"SQnmu","CENTER":"nVOf5","RIGHT":"GAUTu","AUTO":"IjV6v","JUSTIFY":"vVfzz"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-f276b131.js.map
